// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { PersesColor } from './types';

export const orange: PersesColor = {
  50: '#FFF5E8',
  100: '#FFECD2',
  150: '#FFE2BB',
  200: '#FFD9A4',
  300: '#FFC577',
  400: '#FFB249',
  500: '#FF9F1C',
  600: '#CC7F16',
  700: '#995F11',
  800: '#66400B',
  850: '#4D3008',
  900: '#332006',
  950: '#1A1003',
};
